import React from 'react'

import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import { useEventContext } from 'context/EventContext'

import classes from './VerifiedIcon.module.scss'

const getVariantTitle = validationsPassed => {
  if (validationsPassed?.find(v => v === 'BusinessEmail')) {
    return 'Business verified'
  }
  if (validationsPassed?.find(v => v === 'ProofOfLink')) {
    return 'Reviewer identity verified'
  }
  return null
}

// isVerified == is linkedin user
// hasPicture == is linkedin user
// is_validated = used other method to identify a reviewer

/** @type {import('./types').default} */
const VerifiedIcon = ({ validationsPassed, isVerified, isValidated, hasPicture }) => {
  const { sendEvent } = useEventContext()

  if (!isVerified && !isValidated && !hasPicture) {
    return null
  }

  if (validationsPassed?.find(v => v === 'LinkedIn') || isVerified || hasPicture) {
    return (
      <Tooltip
        title="Verified LinkedIn User"
        enterTouchDelay={100}
        leaveTouchDelay={3000}
        sendOnEnterEvents={() => {
          sendEvent({
            name: 'engagement_hover',
            engagementDestination: 'show_linkedin-icon-definition',
            engagementDetails: 'hover_linkedin-icon',
          })
        }}
      >
        <div className={classes.tooltip}>
          <Icon
            icon={['fab', 'linkedin']}
            aria-label="LinkedIn verified user checkmark"
            className={classes.linkedinIcon}
          />
        </div>
      </Tooltip>
    )
  }

  const title = getVariantTitle(validationsPassed)

  return (
    <Tooltip
      title={title}
      sendOnEnterEvents={() => {
        sendEvent({
          name: 'engagement_hover',
          engagementDestination: 'show_verified-icon-definition',
          engagementDetails: 'hover_verified-icon',
        })
      }}
    >
      <div className={classes.tooltip}>
        <Icon icon={['fas', 'badge-check']} className={classes.badge} data-testid="verified-icon" />
      </div>
    </Tooltip>
  )
}

export default VerifiedIcon
